import { Plugin } from "..";
import { defaultEventListDataOptions } from "./event-list-data-options";
import { defaultEventListOptions } from "./event-list-options";

export const EventList: Plugin = {
	id: "event-list",
	type: "event",
	header: {
		visible: true,
		edit: true,
		fullscreen: false,
	},
	name: "eventList",
	component: defineAsyncComponent(() => import("./EventListPlugin.vue")),
	config: defineAsyncComponent(() => import("./EventListPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./EventListPluginDataConfig")),
	defaultDataResolver: () => defaultEventListDataOptions,
	defaultOptionsResolver: () => defaultEventListOptions,
	dimension: {
		minHeight: 4,
		minWidth: 4,
	},

	currentVersion: 1,
	migrations: {},
};
